import React, { useEffect } from 'react';

import { useAppContext } from '@prisjakt/ui-app-context';

import { Pillbox, Pill } from '../pillbox';
import { addRecentSearch } from 'src/areas/search-suggestions/history-storage';

import * as S from './styles';

import {
  trackPopularSearchClicked,
  trackPopularSearchesListed,
} from './tracking';

import { PopularSearch } from 'src/types';

type Props = {
  popularSearches: Array<PopularSearch | null>;
  onClick?: () => void;
};

export const PopularSearches = (props: Props) => {
  const { popularSearches, onClick } = props;
  const { linkTo } = useAppContext();

  useEffect(() => {
    if (popularSearches?.length) {
      trackPopularSearchesListed();
    }
  }, []);

  if (!popularSearches?.length) {
    return null;
  }

  const handleClick = (query: string) => {
    trackPopularSearchClicked(query);
    addRecentSearch(query);
    if (onClick) {
      onClick();
    }
  };

  return (
    <S.PopularSearches data-test="PopularSearchesWrapper">
      <Pillbox>
        {popularSearches.map(
          search =>
            search?.query && (
              <Pill
                key={search.query}
                to={linkTo('search', { query: search.query })}
                onClick={() => handleClick(search.query)}
                containerProps={{
                  'data-test': 'PopularSearchQuery',
                }}
              >
                {search.query}
              </Pill>
            )
        )}
      </Pillbox>
    </S.PopularSearches>
  );
};
